// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* VARIABLES */
/* Applies a stroke to the icons. Can use percentage for responsive */
.climacon_component-stroke {
  fill: #dcdada;
  stroke-width: 1px;
  stroke: #717171; }

.climacon_component-fill {
  fill: #71717140;
  stroke-width: 0;
  stroke: #ddd; }

/* SVG GLOBAL */
svg.climacon {
  display: inline-block;
  width: 80px;
  height: 80px;
  shape-rendering: geometricPrecision; }

g, path, circle, rect {
  animation-iteration-count: infinite;
  animation-timing-function: linear;
  transform-origin: 50% 50%;
  animation-duration: 18s;
  animation-direction: normal; }

/* SUN */
.climacon_componentWrap-sun {
  animation-name: rotate; }

.climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke {
  animation-name: scale;
  animation-direction: alternate;
  animation-duration: 4.5s; }

.climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s; }

/* MOON */
.climacon_componentWrap-moon {
  animation-name: partialRotate;
  animation-duration: 18s;
  animation-direction: alternate; }

/* WIND */
.climacon_componentWrap-wind {
  animation-name: translateWind;
  animation-duration: 6s;
  animation-direction: alternate;
  animation-timing-function: ease-in-out; }

/* SNOWFLAKE */
.climacon_componentWrap-snowflake {
  animation-name: rotate;
  animation-duration: 54s;
  animation-direction: normal; }

/* CLOUD SUN */
.climacon_componentWrap-sun_cloud {
  animation-name: behindCloudMove, rotate;
  animation-iteration-count: 1, infinite;
  animation-timing-function: ease-out, linear;
  animation-delay: 0, 4.5s;
  animation-duration: 4.5s, 18s; }

.climacon_componentWrap-sun_cloud .climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke {
  fill-opacity: 0;
  animation-name: fillOpacity, scale;
  animation-iteration-count: 1, infinite;
  animation-delay: 4.5s, 0;
  animation-fill-mode: both; }

.climacon_componentWrap-sun_cloud .climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s; }

/* CLOUD MOON */
.climacon_componentWrap-moon_cloud {
  animation-name: behindCloudMove, partialRotate;
  animation-iteration-count: 1, infinite;
  animation-timing-function: ease-out, linear;
  animation-delay: 0, 4.5s;
  animation-duration: 4.5s, 18s; }

/* DRIZZLE */
.climacon_component-stroke_drizzle {
  fill-opacity: 0;
  animation-name: drizzleFall, fillOpacity2;
  animation-timing-function: ease-in;
  animation-duration: 1.5s; }

.climacon_component-stroke_drizzle:nth-child(1) {
  animation-delay: 0s; }

.climacon_component-stroke_drizzle:nth-child(2) {
  animation-delay: 0.9s; }

.climacon_component-stroke_drizzle:nth-child(3) {
  animation-delay: 1.8s; }

/* RAIN */
.climacon_component-stroke_rain {
  fill-opacity: 0;
  animation-name: rainFall, fillOpacity2;
  animation-timing-function: ease-in;
  animation-duration: 3s; }

.climacon_component-stroke_rain:nth-child(n+4) {
  animation-delay: 1.5s; }

.climacon_component-stroke_rain_alt:nth-child(2) {
  animation-delay: 1.5s; }

/* HAIL */
/* HAIL ALT */
.climacon_component-stroke_hailAlt {
  fill-opacity: 1;
  animation-timing-function: ease-in;
  animation-duration: 1s; }

.climacon_component-stroke_hailAlt-left {
  animation-name: hailLeft, fillOpacity2; }

.climacon_component-stroke_hailAlt-middle {
  animation-name: hailMiddle, fillOpacity2; }

.climacon_component-stroke_hailAlt-middle:nth-child(2) {
  animation-name: hailMiddle2, fillOpacity2; }

.climacon_component-stroke_hailAlt-right {
  animation-name: hailRight, fillOpacity2; }

.climacon_component-stroke_hailAlt:nth-child(1) {
  animation-delay: 0s; }

.climacon_component-stroke_hailAlt:nth-child(2) {
  animation-delay: 0.1666666667s; }

.climacon_component-stroke_hailAlt:nth-child(3) {
  animation-delay: 0.3333333333s; }

.climacon_component-stroke_hailAlt:nth-child(4) {
  animation-delay: 0.5s; }

.climacon_component-stroke_hailAlt:nth-child(5) {
  animation-delay: 0.6666666667s; }

.climacon_component-stroke_hailAlt:nth-child(6) {
  animation-delay: 0.8333333333s; }

/* SNOW */
.climacon_component-stroke_snow {
  fill-opacity: 0;
  animation-name: snowFall, fillOpacity2;
  animation-timing-function: ease-in-out;
  animation-duration: 9s; }

.climacon_component-stroke_snow:nth-child(3) {
  animation-name: snowFall2, fillOpacity2; }

.climacon_component-stroke_snow:nth-child(1) {
  animation-delay: 0s; }

.climacon_component-stroke_snow:nth-child(2) {
  animation-delay: 3s; }

.climacon_component-stroke_snow:nth-child(3) {
  animation-delay: 6s; }

/* SNOW ALT */
.climacon_wrapperComponent-snowAlt {
  fill-opacity: 0;
  animation-name: snowFall, fillOpacity2;
  animation-timing-function: ease-in-out;
  animation-duration: 9s; }

/* FOG */
.climacon_component-stroke_fogLine {
  fill-opacity: 0.5;
  animation-name: translateFog, fillOpacityFog;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-timing-function: ease-in;
  animation-duration: 18s; }

.climacon_component-stroke_fogLine:nth-child(even) {
  animation-delay: 9s; }

/* LIGHTNING */
.climacon_component-stroke_lightning {
  fill-opacity: 0;
  animation-name: fillOpacityLightning;
  animation-iteration-count: infinite;
  animation-direction: normal;
  animation-timing-function: ease-out;
  animation-duration: 18s; }

/* TORNADO */
.climacon_component-stroke_tornadoLine {
  animation-name: translateTornado1;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  animation-timing-function: ease-in-out;
  animation-duration: 18s; }

.climacon_component-stroke_tornadoLine:nth-child(1) {
  animation-name: translateTornado1; }

.climacon_component-stroke_tornadoLine:nth-child(2) {
  animation-name: translateTornado2; }

.climacon_component-stroke_tornadoLine:nth-child(3) {
  animation-name: translateTornado3; }

.climacon_component-stroke_tornadoLine:nth-child(4) {
  animation-name: translateTornado4; }

.climacon_component-stroke_tornadoLine:nth-child(5) {
  animation-name: translateTornado5; }

.climacon_component-stroke_tornadoLine:nth-child(6) {
  animation-name: translateTornado6; }

.climacon_componentWrap-sunsetAlt {
  animation-name: translateSunset;
  animation-duration: 4.5s;
  animation-iteration-count: 1;
  animation-timing-function: ease-out; }

.climacon_componentWrap-sunsetAlt {
  animation-name: translateSunset;
  animation-iteration-count: 1; }

.climacon_iconWrap-sun .climacon_component-stroke_sunSpoke, .climacon_iconWrap-sunFill .climacon_component-stroke_sunSpoke {
  fill-opacity: 1;
  animation-name: scale;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-delay: 0s;
  animation-fill-mode: both;
  animation-direction: alternate; }

.climacon_iconWrap-sun .climacon_component-stroke_sunSpoke:nth-child(even), .climacon_iconWrap-sunFill .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s; }

.climacon-iconWrap_sunFill .climacon_component-stroke_sunSpoke {
  fill-opacity: 1;
  animation-name: scale;
  animation-iteration-count: infinite;
  animation-delay: 0s;
  animation-fill-mode: both;
  animation-direction: alternate; }

.climacon-iconWrap_sunFill .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s; }

.climacon_component-stroke_arrow-up {
  fill-opacity: 0;
  animation-name: fillOpacity2, translateArrowUp;
  animation-duration: 4.5s; }

.climacon_component-stroke_arrow-down {
  fill-opacity: 0;
  animation-name: fillOpacity2, translateArrowDown;
  animation-duration: 4.5s; }

.climacon_componentWrap-sunrise .climacon_component-stroke_sunSpoke, .climacon_componentWrap-sunset .climacon_component-stroke_sunSpoke {
  animation-name: scale;
  animation-direction: alternate;
  animation-iteration-count: infinite;
  animation-duration: 4.5s;
  animation-delay: 0s;
  animation-fill-mode: both; }

.climacon_componentWrap-sunrise .climacon_component-stroke_sunSpoke:nth-child(even), .climacon_componentWrap-sunset .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s; }

.climacon_componentWrap-sunriseAlt {
  animation-name: translateSunrise, fillOpacity;
  animation-duration: 18s, 9s;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-fill-mode: forwards; }

.climacon_componentWrap-sunriseAlt .climacon_component-stroke_sunSpoke {
  fill-opacity: 0;
  animation-name: fillOpacity, scale;
  animation-direction: normal, alternate;
  animation-iteration-count: 1, infinite;
  animation-duration: 4.5s;
  animation-delay: 4.5s, 0;
  animation-fill-mode: both; }

.climacon_componentWrap-sunriseAlt .climacon_component-stroke_sunSpoke:nth-child(even) {
  animation-delay: 4.5s, 4.5s; }

.climacon_componentWrap-sunsetAlt {
  animation-name: translateSunset;
  animation-delay: 0s;
  animation-duration: 18s;
  animation-direction: normal;
  animation-iteration-count: 1;
  animation-fill-mode: forwards; }

/* ANIMATIONS */
@keyframes rotate {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }
@keyframes partialRotate {
  0% {
    transform: rotate(0deg); }
  25% {
    transform: rotate(-15deg); }
  50% {
    transform: rotate(0deg); }
  75% {
    transform: rotate(15deg); }
  100% {
    transform: rotate(0deg); } }
@keyframes scale {
  0% {
    transform: scale(1, 1); }
  100% {
    transform: scale(0.5, 0.5); } }
@keyframes behindCloudMove {
  0% {
    transform: translateX(-1.75px) translateY(1.75px); }
  100% {
    transform: translateX(0) translateY(0); } }
@keyframes drizzleFall {
  0% {
    transform: translateY(0); }
  100% {
    transform: translateY(21px); } }
@keyframes rainFall {
  0% {
    transform: translateY(0); }
  100% {
    transform: translateY(14px); } }
@keyframes rainFall2 {
  0% {
    transform: translateY(0); }
  50% {
    transform: translateY(14px); }
  100% {
    transform: translateX(14px) translateY(14px); } }
@keyframes hailLeft {
  50% {
    transform: translateY(17.5px); }
  51% {
    transform: translateY(17.5px) translateX(-0.3px); }
  53% {
    transform: translateY(16.4033342063px) translateX(-0.9px); }
  55% {
    transform: translateY(15.3239634873px) translateX(-1.5px); }
  57% {
    transform: translateY(14.278910164px) translateX(-2.1px); }
  59% {
    transform: translateY(13.2846553516px) translateX(-2.7px); }
  61% {
    transform: translateY(12.3568790424px) translateX(-3.3px); }
  63% {
    transform: translateY(11.5102128231px) translateX(-3.9px); }
  65% {
    transform: translateY(10.7580091257px) translateX(-4.5px); }
  67% {
    transform: translateY(10.1121306519px) translateX(-5.1px); }
  69% {
    transform: translateY(9.5827632909px) translateX(-5.7px); }
  71% {
    transform: translateY(9.1782554824px) translateX(-6.3px); }
  73% {
    transform: translateY(8.9049865561px) translateX(-6.9px); }
  75% {
    transform: translateY(8.7672661263px) translateX(-7.5px); }
  77% {
    transform: translateY(8.7672661263px) translateX(-8.1px); }
  79% {
    transform: translateY(8.9049865561px) translateX(-8.7px); }
  81% {
    transform: translateY(9.1782554824px) translateX(-9.3px); }
  83% {
    transform: translateY(9.5827632909px) translateX(-9.9px); }
  85% {
    transform: translateY(10.1121306519px) translateX(-10.5px); }
  87% {
    transform: translateY(10.7580091257px) translateX(-11.1px); }
  89% {
    transform: translateY(11.5102128231px) translateX(-11.7px); }
  91% {
    transform: translateY(12.3568790424px) translateX(-12.3px); }
  93% {
    transform: translateY(13.2846553516px) translateX(-12.9px); }
  95% {
    transform: translateY(14.278910164px) translateX(-13.5px); }
  97% {
    transform: translateY(15.3239634873px) translateX(-14.1px); }
  99% {
    transform: translateY(16.4033342063px) translateX(-14.7px); } }
@keyframes hailMiddle {
  50% {
    transform: translateY(17.5px); }
  51% {
    transform: translateY(17.5px) translateX(-0.15px); }
  53% {
    transform: translateY(16.4033342063px) translateX(-0.45px); }
  55% {
    transform: translateY(15.3239634873px) translateX(-0.75px); }
  57% {
    transform: translateY(14.278910164px) translateX(-1.05px); }
  59% {
    transform: translateY(13.2846553516px) translateX(-1.35px); }
  61% {
    transform: translateY(12.3568790424px) translateX(-1.65px); }
  63% {
    transform: translateY(11.5102128231px) translateX(-1.95px); }
  65% {
    transform: translateY(10.7580091257px) translateX(-2.25px); }
  67% {
    transform: translateY(10.1121306519px) translateX(-2.55px); }
  69% {
    transform: translateY(9.5827632909px) translateX(-2.85px); }
  71% {
    transform: translateY(9.1782554824px) translateX(-3.15px); }
  73% {
    transform: translateY(8.9049865561px) translateX(-3.45px); }
  75% {
    transform: translateY(8.7672661263px) translateX(-3.75px); }
  77% {
    transform: translateY(8.7672661263px) translateX(-4.05px); }
  79% {
    transform: translateY(8.9049865561px) translateX(-4.35px); }
  81% {
    transform: translateY(9.1782554824px) translateX(-4.65px); }
  83% {
    transform: translateY(9.5827632909px) translateX(-4.95px); }
  85% {
    transform: translateY(10.1121306519px) translateX(-5.25px); }
  87% {
    transform: translateY(10.7580091257px) translateX(-5.55px); }
  89% {
    transform: translateY(11.5102128231px) translateX(-5.85px); }
  91% {
    transform: translateY(12.3568790424px) translateX(-6.15px); }
  93% {
    transform: translateY(13.2846553516px) translateX(-6.45px); }
  95% {
    transform: translateY(14.278910164px) translateX(-6.75px); }
  97% {
    transform: translateY(15.3239634873px) translateX(-7.05px); }
  99% {
    transform: translateY(16.4033342063px) translateX(-7.35px); } }
@keyframes hailMiddle2 {
  50% {
    transform: translateY(17.5px); }
  51% {
    transform: translateY(17.5px) translateX(0.15px); }
  53% {
    transform: translateY(16.4033342063px) translateX(0.45px); }
  55% {
    transform: translateY(15.3239634873px) translateX(0.75px); }
  57% {
    transform: translateY(14.278910164px) translateX(1.05px); }
  59% {
    transform: translateY(13.2846553516px) translateX(1.35px); }
  61% {
    transform: translateY(12.3568790424px) translateX(1.65px); }
  63% {
    transform: translateY(11.5102128231px) translateX(1.95px); }
  65% {
    transform: translateY(10.7580091257px) translateX(2.25px); }
  67% {
    transform: translateY(10.1121306519px) translateX(2.55px); }
  69% {
    transform: translateY(9.5827632909px) translateX(2.85px); }
  71% {
    transform: translateY(9.1782554824px) translateX(3.15px); }
  73% {
    transform: translateY(8.9049865561px) translateX(3.45px); }
  75% {
    transform: translateY(8.7672661263px) translateX(3.75px); }
  77% {
    transform: translateY(8.7672661263px) translateX(4.05px); }
  79% {
    transform: translateY(8.9049865561px) translateX(4.35px); }
  81% {
    transform: translateY(9.1782554824px) translateX(4.65px); }
  83% {
    transform: translateY(9.5827632909px) translateX(4.95px); }
  85% {
    transform: translateY(10.1121306519px) translateX(5.25px); }
  87% {
    transform: translateY(10.7580091257px) translateX(5.55px); }
  89% {
    transform: translateY(11.5102128231px) translateX(5.85px); }
  91% {
    transform: translateY(12.3568790424px) translateX(6.15px); }
  93% {
    transform: translateY(13.2846553516px) translateX(6.45px); }
  95% {
    transform: translateY(14.278910164px) translateX(6.75px); }
  97% {
    transform: translateY(15.3239634873px) translateX(7.05px); }
  99% {
    transform: translateY(16.4033342063px) translateX(7.35px); } }
@keyframes hailRight {
  50% {
    transform: translateY(17.5px); }
  51% {
    transform: translateY(17.5px) translateX(0.3px); }
  53% {
    transform: translateY(16.4033342063px) translateX(0.9px); }
  55% {
    transform: translateY(15.3239634873px) translateX(1.5px); }
  57% {
    transform: translateY(14.278910164px) translateX(2.1px); }
  59% {
    transform: translateY(13.2846553516px) translateX(2.7px); }
  61% {
    transform: translateY(12.3568790424px) translateX(3.3px); }
  63% {
    transform: translateY(11.5102128231px) translateX(3.9px); }
  65% {
    transform: translateY(10.7580091257px) translateX(4.5px); }
  67% {
    transform: translateY(10.1121306519px) translateX(5.1px); }
  69% {
    transform: translateY(9.5827632909px) translateX(5.7px); }
  71% {
    transform: translateY(9.1782554824px) translateX(6.3px); }
  73% {
    transform: translateY(8.9049865561px) translateX(6.9px); }
  75% {
    transform: translateY(8.7672661263px) translateX(7.5px); }
  77% {
    transform: translateY(8.7672661263px) translateX(8.1px); }
  79% {
    transform: translateY(8.9049865561px) translateX(8.7px); }
  81% {
    transform: translateY(9.1782554824px) translateX(9.3px); }
  83% {
    transform: translateY(9.5827632909px) translateX(9.9px); }
  85% {
    transform: translateY(10.1121306519px) translateX(10.5px); }
  87% {
    transform: translateY(10.7580091257px) translateX(11.1px); }
  89% {
    transform: translateY(11.5102128231px) translateX(11.7px); }
  91% {
    transform: translateY(12.3568790424px) translateX(12.3px); }
  93% {
    transform: translateY(13.2846553516px) translateX(12.9px); }
  95% {
    transform: translateY(14.278910164px) translateX(13.5px); }
  97% {
    transform: translateY(15.3239634873px) translateX(14.1px); }
  99% {
    transform: translateY(16.4033342063px) translateX(14.7px); } }
@keyframes fillOpacity {
  0% {
    fill-opacity: 0;
    stroke-opacity: 0; }
  100% {
    fill-opacity: 1;
    stroke-opacity: 1; } }
@keyframes fillOpacity2 {
  0% {
    fill-opacity: 0;
    stroke-opacity: 0; }
  50% {
    fill-opacity: 1;
    stroke-opacity: 1; }
  100% {
    fill-opacity: 0;
    stroke-opacity: 0; } }
@keyframes lightningFlash {
  0% {
    fill-opacity: 0; }
  1% {
    fill-opacity: 1; }
  2% {
    fill-opacity: 0; }
  50% {
    fill-opacity: 0; }
  51% {
    fill-opacity: 1; }
  52% {
    fill-opacity: 0; }
  53% {
    fill-opacity: 1; }
  54% {
    fill-opacity: 0; }
  100% {
    fill-opacity: 0; } }
@keyframes snowFall {
  0% {
    transform: translateY(0px) translateX(0px); }
  2% {
    transform: translateY(0.35px) translateX(0.7534862344px); }
  4% {
    transform: translateY(0.7px) translateX(1.441332186px); }
  6% {
    transform: translateY(1.05px) translateX(2.0611944604px); }
  8% {
    transform: translateY(1.4px) translateX(2.6112438152px); }
  10% {
    transform: translateY(1.75px) translateX(3.0901699437px); }
  12% {
    transform: translateY(2.1px) translateX(3.4971832505px); }
  14% {
    transform: translateY(2.45px) translateX(3.8320136241px); }
  16% {
    transform: translateY(2.8px) translateX(4.0949062299px); }
  18% {
    transform: translateY(3.15px) translateX(4.2866143598px); }
  20% {
    transform: translateY(3.5px) translateX(4.4083893922px); }
  22% {
    transform: translateY(3.85px) translateX(4.4619679282px); }
  24% {
    transform: translateY(4.2px) translateX(4.4495561885px); }
  26% {
    transform: translateY(4.55px) translateX(4.3738117645px); }
  28% {
    transform: translateY(4.9px) translateX(4.2378228353px); }
  30% {
    transform: translateY(5.25px) translateX(4.0450849719px); }
  32% {
    transform: translateY(5.6px) translateX(3.7994756648px); }
  34% {
    transform: translateY(5.95px) translateX(3.5052267202px); }
  36% {
    transform: translateY(6.3px) translateX(3.1668946836px); }
  38% {
    transform: translateY(6.65px) translateX(2.7893294577px); }
  40% {
    transform: translateY(7px) translateX(2.3776412907px); }
  42% {
    transform: translateY(7.35px) translateX(1.9371663223px); }
  44% {
    transform: translateY(7.7px) translateX(1.4734308761px); }
  46% {
    transform: translateY(8.05px) translateX(0.9921147013px); }
  48% {
    transform: translateY(8.4px) translateX(0.4990133642px); }
  50% {
    transform: translateY(8.75px) translateX(0px); }
  52% {
    transform: translateY(9.1px) translateX(-0.4990133642px); }
  54% {
    transform: translateY(9.45px) translateX(-0.9921147013px); }
  56% {
    transform: translateY(9.8px) translateX(-1.4734308761px); }
  58% {
    transform: translateY(10.15px) translateX(-1.9371663223px); }
  60% {
    transform: translateY(10.5px) translateX(-2.3776412907px); }
  62% {
    transform: translateY(10.85px) translateX(-2.7893294577px); }
  64% {
    transform: translateY(11.2px) translateX(-3.1668946836px); }
  66% {
    transform: translateY(11.55px) translateX(-3.5052267202px); }
  68% {
    transform: translateY(11.9px) translateX(-3.7994756648px); }
  70% {
    transform: translateY(12.25px) translateX(-4.0450849719px); }
  72% {
    transform: translateY(12.6px) translateX(-4.2378228353px); }
  74% {
    transform: translateY(12.95px) translateX(-4.3738117645px); }
  76% {
    transform: translateY(13.3px) translateX(-4.4495561885px); }
  78% {
    transform: translateY(13.65px) translateX(-4.4619679282px); }
  80% {
    transform: translateY(14px) translateX(-4.4083893922px); }
  82% {
    transform: translateY(14.35px) translateX(-4.2866143598px); }
  84% {
    transform: translateY(14.7px) translateX(-4.0949062299px); }
  86% {
    transform: translateY(15.05px) translateX(-3.8320136241px); }
  88% {
    transform: translateY(15.4px) translateX(-3.4971832505px); }
  90% {
    transform: translateY(15.75px) translateX(-3.0901699438px); }
  92% {
    transform: translateY(16.1px) translateX(-2.6112438152px); }
  94% {
    transform: translateY(16.45px) translateX(-2.0611944605px); }
  96% {
    transform: translateY(16.8px) translateX(-1.441332186px); }
  98% {
    transform: translateY(17.15px) translateX(-0.7534862344px); }
  100% {
    transform: translateY(17.5px) translateX(-0.0000000001px); } }
@keyframes snowFall2 {
  0% {
    transform: translateY(0px) translateX(0px); }
  2% {
    transform: translateY(0.35px) translateX(-0.7534862344px); }
  4% {
    transform: translateY(0.7px) translateX(-1.441332186px); }
  6% {
    transform: translateY(1.05px) translateX(-2.0611944604px); }
  8% {
    transform: translateY(1.4px) translateX(-2.6112438152px); }
  10% {
    transform: translateY(1.75px) translateX(-3.0901699437px); }
  12% {
    transform: translateY(2.1px) translateX(-3.4971832505px); }
  14% {
    transform: translateY(2.45px) translateX(-3.8320136241px); }
  16% {
    transform: translateY(2.8px) translateX(-4.0949062299px); }
  18% {
    transform: translateY(3.15px) translateX(-4.2866143598px); }
  20% {
    transform: translateY(3.5px) translateX(-4.4083893922px); }
  22% {
    transform: translateY(3.85px) translateX(-4.4619679282px); }
  24% {
    transform: translateY(4.2px) translateX(-4.4495561885px); }
  26% {
    transform: translateY(4.55px) translateX(-4.3738117645px); }
  28% {
    transform: translateY(4.9px) translateX(-4.2378228353px); }
  30% {
    transform: translateY(5.25px) translateX(-4.0450849719px); }
  32% {
    transform: translateY(5.6px) translateX(-3.7994756648px); }
  34% {
    transform: translateY(5.95px) translateX(-3.5052267202px); }
  36% {
    transform: translateY(6.3px) translateX(-3.1668946836px); }
  38% {
    transform: translateY(6.65px) translateX(-2.7893294577px); }
  40% {
    transform: translateY(7px) translateX(-2.3776412907px); }
  42% {
    transform: translateY(7.35px) translateX(-1.9371663223px); }
  44% {
    transform: translateY(7.7px) translateX(-1.4734308761px); }
  46% {
    transform: translateY(8.05px) translateX(-0.9921147013px); }
  48% {
    transform: translateY(8.4px) translateX(-0.4990133642px); }
  50% {
    transform: translateY(8.75px) translateX(0px); }
  52% {
    transform: translateY(9.1px) translateX(0.4990133642px); }
  54% {
    transform: translateY(9.45px) translateX(0.9921147013px); }
  56% {
    transform: translateY(9.8px) translateX(1.4734308761px); }
  58% {
    transform: translateY(10.15px) translateX(1.9371663223px); }
  60% {
    transform: translateY(10.5px) translateX(2.3776412907px); }
  62% {
    transform: translateY(10.85px) translateX(2.7893294577px); }
  64% {
    transform: translateY(11.2px) translateX(3.1668946836px); }
  66% {
    transform: translateY(11.55px) translateX(3.5052267202px); }
  68% {
    transform: translateY(11.9px) translateX(3.7994756648px); }
  70% {
    transform: translateY(12.25px) translateX(4.0450849719px); }
  72% {
    transform: translateY(12.6px) translateX(4.2378228353px); }
  74% {
    transform: translateY(12.95px) translateX(4.3738117645px); }
  76% {
    transform: translateY(13.3px) translateX(4.4495561885px); }
  78% {
    transform: translateY(13.65px) translateX(4.4619679282px); }
  80% {
    transform: translateY(14px) translateX(4.4083893922px); }
  82% {
    transform: translateY(14.35px) translateX(4.2866143598px); }
  84% {
    transform: translateY(14.7px) translateX(4.0949062299px); }
  86% {
    transform: translateY(15.05px) translateX(3.8320136241px); }
  88% {
    transform: translateY(15.4px) translateX(3.4971832505px); }
  90% {
    transform: translateY(15.75px) translateX(3.0901699438px); }
  92% {
    transform: translateY(16.1px) translateX(2.6112438152px); }
  94% {
    transform: translateY(16.45px) translateX(2.0611944605px); }
  96% {
    transform: translateY(16.8px) translateX(1.441332186px); }
  98% {
    transform: translateY(17.15px) translateX(0.7534862344px); }
  100% {
    transform: translateY(17.5px) translateX(0.0000000001px); } }
/* Tornado */
@keyframes translateTornado1 {
  0% {
    transform: translateY(0); }
  25% {
    transform: translateX(3.997px); }
  75% {
    transform: translateX(-3.997px); }
  100% {
    transform: translateX(0); } }
@keyframes translateTornado2 {
  0% {
    transform: translateY(0); }
  25% {
    transform: translateX(2.002px); }
  75% {
    transform: translateX(-2.002px); }
  100% {
    transform: translateX(0); } }
@keyframes translateTornado3 {
  0% {
    transform: translateY(0); }
  25% {
    transform: translateX(8.001px); }
  75% {
    transform: translateX(-8.001px); }
  100% {
    transform: translateX(0); } }
@keyframes translateTornado4 {
  0% {
    transform: translateY(0); }
  25% {
    transform: translateX(5.999px); }
  75% {
    transform: translateX(-5.999px); }
  100% {
    transform: translateX(0); } }
@keyframes translateTornado5 {
  0% {
    transform: translateY(0); }
  25% {
    transform: translateX(10.003px); }
  75% {
    transform: translateX(-10.003px); }
  100% {
    transform: translateX(0); } }
@keyframes translateTornado6 {
  0% {
    transform: translateY(0); }
  25% {
    transform: translateX(5.999px); }
  75% {
    transform: translateX(-5.999px); }
  100% {
    transform: translateX(0); } }
@keyframes fillOpacityLightning {
  0% {
    fill-opacity: 0;
    stroke-opacity: 0; }
  1% {
    fill-opacity: 1;
    stroke-opacity: 1; }
  7% {
    fill-opacity: 0;
    stroke-opacity: 0; }
  50% {
    fill-opacity: 0;
    stroke-opacity: 0; }
  51% {
    fill-opacity: 1;
    stroke-opacity: 1; }
  53% {
    fill-opacity: 0;
    stroke-opacity: 0; }
  54% {
    fill-opacity: 1;
    stroke-opacity: 1; }
  60% {
    fill-opacity: 0;
    stroke-opacity: 0; }
  100% {
    fill-opacity: 0;
    stroke-opacity: 0; } }
@keyframes translateFog {
  0% {
    transform: translateY(0); }
  25% {
    transform: translateX(2.499px); }
  75% {
    transform: translateX(-2.499px); }
  100% {
    transform: translateX(0); } }
@keyframes fillOpacityFog {
  0% {
    fill-opacity: 0.5;
    stroke-opacity: 0.5; }
  50% {
    fill-opacity: 1;
    stroke-opacity: 1; }
  100% {
    fill-opacity: 0.5;
    stroke-opacity: 0.5; } }
@keyframes translateSunrise {
  0% {
    transform: translateY(0); }
  25% {
    transform: translateY(-16.002px); }
  100% {
    transform: translateY(-16.002px); } }
@keyframes translateSunset {
  0% {
    transform: translateY(-16.002px); }
  25% {
    transform: translateY(-3.997px); }
  100% {
    transform: translateY(-3.997px); } }
@keyframes translateArrowDown {
  0% {
    transform: translateY(2.002px); }
  100% {
    transform: translateY(4.998px); } }
@keyframes translateArrowUp {
  0% {
    transform: translateY(-2.002px); }
  100% {
    transform: translateY(-4.998px); } }
@keyframes translateWind {
  0% {
    transform: translateY(0); }
  25% {
    transform: translateX(4.998px); }
  75% {
    transform: translateX(-4.998px); }
  100% {
    transform: translateX(0); } }
`, "",{"version":3,"sources":["webpack://./src/assets/css/svg-icon.css"],"names":[],"mappings":"AAAA,cAAc;AACd,qEAAqE;AACrE;EACE,aAAa;EACb,iBAAiB;EACjB,eAAe,EAAE;;AAEnB;EACE,eAAe;EACf,eAAe;EACf,YAAY,EAAE;;AAEhB,eAAe;AACf;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,mCAAmC,EAAE;;AAEvC;EACE,mCAAmC;EACnC,iCAAiC;EACjC,yBAAyB;EACzB,uBAAuB;EACvB,2BAA2B,EAAE;;AAE/B,QAAQ;AACR;EACE,sBAAsB,EAAE;;AAE1B;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,wBAAwB,EAAE;;AAE5B;EACE,qBAAqB,EAAE;;AAEzB,SAAS;AACT;EACE,6BAA6B;EAC7B,uBAAuB;EACvB,8BAA8B,EAAE;;AAElC,SAAS;AACT;EACE,6BAA6B;EAC7B,sBAAsB;EACtB,8BAA8B;EAC9B,sCAAsC,EAAE;;AAE1C,cAAc;AACd;EACE,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B,EAAE;;AAE/B,cAAc;AACd;EACE,uCAAuC;EACvC,sCAAsC;EACtC,2CAA2C;EAC3C,wBAAwB;EACxB,6BAA6B,EAAE;;AAEjC;EACE,eAAe;EACf,kCAAkC;EAClC,sCAAsC;EACtC,wBAAwB;EACxB,yBAAyB,EAAE;;AAE7B;EACE,qBAAqB,EAAE;;AAEzB,eAAe;AACf;EACE,8CAA8C;EAC9C,sCAAsC;EACtC,2CAA2C;EAC3C,wBAAwB;EACxB,6BAA6B,EAAE;;AAEjC,YAAY;AACZ;EACE,eAAe;EACf,yCAAyC;EACzC,kCAAkC;EAClC,wBAAwB,EAAE;;AAE5B;EACE,mBAAmB,EAAE;;AAEvB;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB,SAAS;AACT;EACE,eAAe;EACf,sCAAsC;EACtC,kCAAkC;EAClC,sBAAsB,EAAE;;AAE1B;EACE,qBAAqB,EAAE;;AAEzB;EACE,qBAAqB,EAAE;;AAEzB,SAAS;AACT,aAAa;AACb;EACE,eAAe;EACf,kCAAkC;EAClC,sBAAsB,EAAE;;AAE1B;EACE,sCAAsC,EAAE;;AAE1C;EACE,wCAAwC,EAAE;;AAE5C;EACE,yCAAyC,EAAE;;AAE7C;EACE,uCAAuC,EAAE;;AAE3C;EACE,mBAAmB,EAAE;;AAEvB;EACE,8BAA8B,EAAE;;AAElC;EACE,8BAA8B,EAAE;;AAElC;EACE,qBAAqB,EAAE;;AAEzB;EACE,8BAA8B,EAAE;;AAElC;EACE,8BAA8B,EAAE;;AAElC,SAAS;AACT;EACE,eAAe;EACf,sCAAsC;EACtC,sCAAsC;EACtC,sBAAsB,EAAE;;AAE1B;EACE,uCAAuC,EAAE;;AAE3C;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB;EACE,mBAAmB,EAAE;;AAEvB,aAAa;AACb;EACE,eAAe;EACf,sCAAsC;EACtC,sCAAsC;EACtC,sBAAsB,EAAE;;AAE1B,QAAQ;AACR;EACE,iBAAiB;EACjB,4CAA4C;EAC5C,mCAAmC;EACnC,2BAA2B;EAC3B,kCAAkC;EAClC,uBAAuB,EAAE;;AAE3B;EACE,mBAAmB,EAAE;;AAEvB,cAAc;AACd;EACE,eAAe;EACf,oCAAoC;EACpC,mCAAmC;EACnC,2BAA2B;EAC3B,mCAAmC;EACnC,uBAAuB,EAAE;;AAE3B,YAAY;AACZ;EACE,iCAAiC;EACjC,mCAAmC;EACnC,8BAA8B;EAC9B,sCAAsC;EACtC,uBAAuB,EAAE;;AAE3B;EACE,iCAAiC,EAAE;;AAErC;EACE,iCAAiC,EAAE;;AAErC;EACE,iCAAiC,EAAE;;AAErC;EACE,iCAAiC,EAAE;;AAErC;EACE,iCAAiC,EAAE;;AAErC;EACE,iCAAiC,EAAE;;AAErC;EACE,+BAA+B;EAC/B,wBAAwB;EACxB,4BAA4B;EAC5B,mCAAmC,EAAE;;AAEvC;EACE,+BAA+B;EAC/B,4BAA4B,EAAE;;AAEhC;EACE,eAAe;EACf,qBAAqB;EACrB,sBAAsB;EACtB,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B,EAAE;;AAElC;EACE,qBAAqB,EAAE;;AAEzB;EACE,eAAe;EACf,qBAAqB;EACrB,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B,EAAE;;AAElC;EACE,qBAAqB,EAAE;;AAEzB;EACE,eAAe;EACf,8CAA8C;EAC9C,wBAAwB,EAAE;;AAE5B;EACE,eAAe;EACf,gDAAgD;EAChD,wBAAwB,EAAE;;AAE5B;EACE,qBAAqB;EACrB,8BAA8B;EAC9B,mCAAmC;EACnC,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB,EAAE;;AAE7B;EACE,qBAAqB,EAAE;;AAEzB;EACE,6CAA6C;EAC7C,2BAA2B;EAC3B,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B,EAAE;;AAEjC;EACE,eAAe;EACf,kCAAkC;EAClC,sCAAsC;EACtC,sCAAsC;EACtC,wBAAwB;EACxB,wBAAwB;EACxB,yBAAyB,EAAE;;AAE7B;EACE,2BAA2B,EAAE;;AAE/B;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,4BAA4B;EAC5B,6BAA6B,EAAE;;AAEjC,eAAe;AACf;EACE;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE,EAAE;AACjC;EACE;IACE,uBAAuB,EAAE;EAC3B;IACE,yBAAyB,EAAE;EAC7B;IACE,uBAAuB,EAAE;EAC3B;IACE,wBAAwB,EAAE;EAC5B;IACE,uBAAuB,EAAE,EAAE;AAC/B;EACE;IACE,sBAAsB,EAAE;EAC1B;IACE,0BAA0B,EAAE,EAAE;AAClC;EACE;IACE,iDAAiD,EAAE;EACrD;IACE,sCAAsC,EAAE,EAAE;AAC9C;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,2BAA2B,EAAE,EAAE;AACnC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,2BAA2B,EAAE,EAAE;AACnC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,2BAA2B,EAAE;EAC/B;IACE,4CAA4C,EAAE,EAAE;AACpD;EACE;IACE,6BAA6B,EAAE;EACjC;IACE,gDAAgD,EAAE;EACpD;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE,EAAE;AAClE;EACE;IACE,6BAA6B,EAAE;EACjC;IACE,iDAAiD,EAAE;EACrD;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,0DAA0D,EAAE,EAAE;AAClE;EACE;IACE,6BAA6B,EAAE;EACjC;IACE,gDAAgD,EAAE;EACpD;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE,EAAE;AACjE;EACE;IACE,6BAA6B,EAAE;EACjC;IACE,+CAA+C,EAAE;EACnD;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,uDAAuD,EAAE;EAC3D;IACE,uDAAuD,EAAE;EAC3D;IACE,uDAAuD,EAAE;EAC3D;IACE,uDAAuD,EAAE;EAC3D;IACE,uDAAuD,EAAE;EAC3D;IACE,uDAAuD,EAAE;EAC3D;IACE,uDAAuD,EAAE;EAC3D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,yDAAyD,EAAE,EAAE;AACjE;EACE;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,iBAAiB,EAAE,EAAE;AACzB;EACE;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,iBAAiB,EAAE,EAAE;AACzB;EACE;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE;EACnB;IACE,eAAe,EAAE,EAAE;AACvB;EACE;IACE,0CAA0C,EAAE;EAC9C;IACE,wDAAwD,EAAE;EAC5D;IACE,sDAAsD,EAAE;EAC1D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,wDAAwD,EAAE;EAC5D;IACE,qDAAqD,EAAE;EACzD;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,6CAA6C,EAAE;EACjD;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,uDAAuD,EAAE;EAC3D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE;EAC7D;IACE,0DAA0D,EAAE;EAC9D;IACE,wDAAwD,EAAE;EAC5D;IACE,0DAA0D,EAAE;EAC9D;IACE,yDAAyD,EAAE,EAAE;AACjE;EACE;IACE,0CAA0C,EAAE;EAC9C;IACE,yDAAyD,EAAE;EAC7D;IACE,uDAAuD,EAAE;EAC3D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,sDAAsD,EAAE;EAC1D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,6CAA6C,EAAE;EACjD;IACE,uDAAuD,EAAE;EAC3D;IACE,wDAAwD,EAAE;EAC5D;IACE,uDAAuD,EAAE;EAC3D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,sDAAsD,EAAE;EAC1D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE;EAC5D;IACE,yDAAyD,EAAE;EAC7D;IACE,uDAAuD,EAAE;EAC3D;IACE,yDAAyD,EAAE;EAC7D;IACE,wDAAwD,EAAE,EAAE;AAChE,YAAY;AACZ;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,8BAA8B,EAAE;EAClC;IACE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE,EAAE;AAChC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,8BAA8B,EAAE;EAClC;IACE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE,EAAE;AAChC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,8BAA8B,EAAE;EAClC;IACE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE,EAAE;AAChC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,8BAA8B,EAAE;EAClC;IACE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE,EAAE;AAChC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,+BAA+B,EAAE;EACnC;IACE,gCAAgC,EAAE;EACpC;IACE,wBAAwB,EAAE,EAAE;AAChC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,8BAA8B,EAAE;EAClC;IACE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE,EAAE;AAChC;EACE;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,eAAe;IACf,iBAAiB,EAAE,EAAE;AACzB;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,8BAA8B,EAAE;EAClC;IACE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE,EAAE;AAChC;EACE;IACE,iBAAiB;IACjB,mBAAmB,EAAE;EACvB;IACE,eAAe;IACf,iBAAiB,EAAE;EACrB;IACE,iBAAiB;IACjB,mBAAmB,EAAE,EAAE;AAC3B;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,gCAAgC,EAAE;EACpC;IACE,gCAAgC,EAAE,EAAE;AACxC;EACE;IACE,gCAAgC,EAAE;EACpC;IACE,+BAA+B,EAAE;EACnC;IACE,+BAA+B,EAAE,EAAE;AACvC;EACE;IACE,8BAA8B,EAAE;EAClC;IACE,8BAA8B,EAAE,EAAE;AACtC;EACE;IACE,+BAA+B,EAAE;EACnC;IACE,+BAA+B,EAAE,EAAE;AACvC;EACE;IACE,wBAAwB,EAAE;EAC5B;IACE,8BAA8B,EAAE;EAClC;IACE,+BAA+B,EAAE;EACnC;IACE,wBAAwB,EAAE,EAAE","sourcesContent":["/* VARIABLES */\n/* Applies a stroke to the icons. Can use percentage for responsive */\n.climacon_component-stroke {\n  fill: #dcdada;\n  stroke-width: 1px;\n  stroke: #717171; }\n\n.climacon_component-fill {\n  fill: #71717140;\n  stroke-width: 0;\n  stroke: #ddd; }\n\n/* SVG GLOBAL */\nsvg.climacon {\n  display: inline-block;\n  width: 80px;\n  height: 80px;\n  shape-rendering: geometricPrecision; }\n\ng, path, circle, rect {\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n  transform-origin: 50% 50%;\n  animation-duration: 18s;\n  animation-direction: normal; }\n\n/* SUN */\n.climacon_componentWrap-sun {\n  animation-name: rotate; }\n\n.climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke {\n  animation-name: scale;\n  animation-direction: alternate;\n  animation-duration: 4.5s; }\n\n.climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s; }\n\n/* MOON */\n.climacon_componentWrap-moon {\n  animation-name: partialRotate;\n  animation-duration: 18s;\n  animation-direction: alternate; }\n\n/* WIND */\n.climacon_componentWrap-wind {\n  animation-name: translateWind;\n  animation-duration: 6s;\n  animation-direction: alternate;\n  animation-timing-function: ease-in-out; }\n\n/* SNOWFLAKE */\n.climacon_componentWrap-snowflake {\n  animation-name: rotate;\n  animation-duration: 54s;\n  animation-direction: normal; }\n\n/* CLOUD SUN */\n.climacon_componentWrap-sun_cloud {\n  animation-name: behindCloudMove, rotate;\n  animation-iteration-count: 1, infinite;\n  animation-timing-function: ease-out, linear;\n  animation-delay: 0, 4.5s;\n  animation-duration: 4.5s, 18s; }\n\n.climacon_componentWrap-sun_cloud .climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke {\n  fill-opacity: 0;\n  animation-name: fillOpacity, scale;\n  animation-iteration-count: 1, infinite;\n  animation-delay: 4.5s, 0;\n  animation-fill-mode: both; }\n\n.climacon_componentWrap-sun_cloud .climacon_componentWrap_sunSpoke .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s; }\n\n/* CLOUD MOON */\n.climacon_componentWrap-moon_cloud {\n  animation-name: behindCloudMove, partialRotate;\n  animation-iteration-count: 1, infinite;\n  animation-timing-function: ease-out, linear;\n  animation-delay: 0, 4.5s;\n  animation-duration: 4.5s, 18s; }\n\n/* DRIZZLE */\n.climacon_component-stroke_drizzle {\n  fill-opacity: 0;\n  animation-name: drizzleFall, fillOpacity2;\n  animation-timing-function: ease-in;\n  animation-duration: 1.5s; }\n\n.climacon_component-stroke_drizzle:nth-child(1) {\n  animation-delay: 0s; }\n\n.climacon_component-stroke_drizzle:nth-child(2) {\n  animation-delay: 0.9s; }\n\n.climacon_component-stroke_drizzle:nth-child(3) {\n  animation-delay: 1.8s; }\n\n/* RAIN */\n.climacon_component-stroke_rain {\n  fill-opacity: 0;\n  animation-name: rainFall, fillOpacity2;\n  animation-timing-function: ease-in;\n  animation-duration: 3s; }\n\n.climacon_component-stroke_rain:nth-child(n+4) {\n  animation-delay: 1.5s; }\n\n.climacon_component-stroke_rain_alt:nth-child(2) {\n  animation-delay: 1.5s; }\n\n/* HAIL */\n/* HAIL ALT */\n.climacon_component-stroke_hailAlt {\n  fill-opacity: 1;\n  animation-timing-function: ease-in;\n  animation-duration: 1s; }\n\n.climacon_component-stroke_hailAlt-left {\n  animation-name: hailLeft, fillOpacity2; }\n\n.climacon_component-stroke_hailAlt-middle {\n  animation-name: hailMiddle, fillOpacity2; }\n\n.climacon_component-stroke_hailAlt-middle:nth-child(2) {\n  animation-name: hailMiddle2, fillOpacity2; }\n\n.climacon_component-stroke_hailAlt-right {\n  animation-name: hailRight, fillOpacity2; }\n\n.climacon_component-stroke_hailAlt:nth-child(1) {\n  animation-delay: 0s; }\n\n.climacon_component-stroke_hailAlt:nth-child(2) {\n  animation-delay: 0.1666666667s; }\n\n.climacon_component-stroke_hailAlt:nth-child(3) {\n  animation-delay: 0.3333333333s; }\n\n.climacon_component-stroke_hailAlt:nth-child(4) {\n  animation-delay: 0.5s; }\n\n.climacon_component-stroke_hailAlt:nth-child(5) {\n  animation-delay: 0.6666666667s; }\n\n.climacon_component-stroke_hailAlt:nth-child(6) {\n  animation-delay: 0.8333333333s; }\n\n/* SNOW */\n.climacon_component-stroke_snow {\n  fill-opacity: 0;\n  animation-name: snowFall, fillOpacity2;\n  animation-timing-function: ease-in-out;\n  animation-duration: 9s; }\n\n.climacon_component-stroke_snow:nth-child(3) {\n  animation-name: snowFall2, fillOpacity2; }\n\n.climacon_component-stroke_snow:nth-child(1) {\n  animation-delay: 0s; }\n\n.climacon_component-stroke_snow:nth-child(2) {\n  animation-delay: 3s; }\n\n.climacon_component-stroke_snow:nth-child(3) {\n  animation-delay: 6s; }\n\n/* SNOW ALT */\n.climacon_wrapperComponent-snowAlt {\n  fill-opacity: 0;\n  animation-name: snowFall, fillOpacity2;\n  animation-timing-function: ease-in-out;\n  animation-duration: 9s; }\n\n/* FOG */\n.climacon_component-stroke_fogLine {\n  fill-opacity: 0.5;\n  animation-name: translateFog, fillOpacityFog;\n  animation-iteration-count: infinite;\n  animation-direction: normal;\n  animation-timing-function: ease-in;\n  animation-duration: 18s; }\n\n.climacon_component-stroke_fogLine:nth-child(even) {\n  animation-delay: 9s; }\n\n/* LIGHTNING */\n.climacon_component-stroke_lightning {\n  fill-opacity: 0;\n  animation-name: fillOpacityLightning;\n  animation-iteration-count: infinite;\n  animation-direction: normal;\n  animation-timing-function: ease-out;\n  animation-duration: 18s; }\n\n/* TORNADO */\n.climacon_component-stroke_tornadoLine {\n  animation-name: translateTornado1;\n  animation-iteration-count: infinite;\n  animation-direction: alternate;\n  animation-timing-function: ease-in-out;\n  animation-duration: 18s; }\n\n.climacon_component-stroke_tornadoLine:nth-child(1) {\n  animation-name: translateTornado1; }\n\n.climacon_component-stroke_tornadoLine:nth-child(2) {\n  animation-name: translateTornado2; }\n\n.climacon_component-stroke_tornadoLine:nth-child(3) {\n  animation-name: translateTornado3; }\n\n.climacon_component-stroke_tornadoLine:nth-child(4) {\n  animation-name: translateTornado4; }\n\n.climacon_component-stroke_tornadoLine:nth-child(5) {\n  animation-name: translateTornado5; }\n\n.climacon_component-stroke_tornadoLine:nth-child(6) {\n  animation-name: translateTornado6; }\n\n.climacon_componentWrap-sunsetAlt {\n  animation-name: translateSunset;\n  animation-duration: 4.5s;\n  animation-iteration-count: 1;\n  animation-timing-function: ease-out; }\n\n.climacon_componentWrap-sunsetAlt {\n  animation-name: translateSunset;\n  animation-iteration-count: 1; }\n\n.climacon_iconWrap-sun .climacon_component-stroke_sunSpoke, .climacon_iconWrap-sunFill .climacon_component-stroke_sunSpoke {\n  fill-opacity: 1;\n  animation-name: scale;\n  animation-duration: 3s;\n  animation-iteration-count: infinite;\n  animation-delay: 0s;\n  animation-fill-mode: both;\n  animation-direction: alternate; }\n\n.climacon_iconWrap-sun .climacon_component-stroke_sunSpoke:nth-child(even), .climacon_iconWrap-sunFill .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s; }\n\n.climacon-iconWrap_sunFill .climacon_component-stroke_sunSpoke {\n  fill-opacity: 1;\n  animation-name: scale;\n  animation-iteration-count: infinite;\n  animation-delay: 0s;\n  animation-fill-mode: both;\n  animation-direction: alternate; }\n\n.climacon-iconWrap_sunFill .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s; }\n\n.climacon_component-stroke_arrow-up {\n  fill-opacity: 0;\n  animation-name: fillOpacity2, translateArrowUp;\n  animation-duration: 4.5s; }\n\n.climacon_component-stroke_arrow-down {\n  fill-opacity: 0;\n  animation-name: fillOpacity2, translateArrowDown;\n  animation-duration: 4.5s; }\n\n.climacon_componentWrap-sunrise .climacon_component-stroke_sunSpoke, .climacon_componentWrap-sunset .climacon_component-stroke_sunSpoke {\n  animation-name: scale;\n  animation-direction: alternate;\n  animation-iteration-count: infinite;\n  animation-duration: 4.5s;\n  animation-delay: 0s;\n  animation-fill-mode: both; }\n\n.climacon_componentWrap-sunrise .climacon_component-stroke_sunSpoke:nth-child(even), .climacon_componentWrap-sunset .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s; }\n\n.climacon_componentWrap-sunriseAlt {\n  animation-name: translateSunrise, fillOpacity;\n  animation-duration: 18s, 9s;\n  animation-direction: normal;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards; }\n\n.climacon_componentWrap-sunriseAlt .climacon_component-stroke_sunSpoke {\n  fill-opacity: 0;\n  animation-name: fillOpacity, scale;\n  animation-direction: normal, alternate;\n  animation-iteration-count: 1, infinite;\n  animation-duration: 4.5s;\n  animation-delay: 4.5s, 0;\n  animation-fill-mode: both; }\n\n.climacon_componentWrap-sunriseAlt .climacon_component-stroke_sunSpoke:nth-child(even) {\n  animation-delay: 4.5s, 4.5s; }\n\n.climacon_componentWrap-sunsetAlt {\n  animation-name: translateSunset;\n  animation-delay: 0s;\n  animation-duration: 18s;\n  animation-direction: normal;\n  animation-iteration-count: 1;\n  animation-fill-mode: forwards; }\n\n/* ANIMATIONS */\n@keyframes rotate {\n  0% {\n    transform: rotate(0deg); }\n  100% {\n    transform: rotate(360deg); } }\n@keyframes partialRotate {\n  0% {\n    transform: rotate(0deg); }\n  25% {\n    transform: rotate(-15deg); }\n  50% {\n    transform: rotate(0deg); }\n  75% {\n    transform: rotate(15deg); }\n  100% {\n    transform: rotate(0deg); } }\n@keyframes scale {\n  0% {\n    transform: scale(1, 1); }\n  100% {\n    transform: scale(0.5, 0.5); } }\n@keyframes behindCloudMove {\n  0% {\n    transform: translateX(-1.75px) translateY(1.75px); }\n  100% {\n    transform: translateX(0) translateY(0); } }\n@keyframes drizzleFall {\n  0% {\n    transform: translateY(0); }\n  100% {\n    transform: translateY(21px); } }\n@keyframes rainFall {\n  0% {\n    transform: translateY(0); }\n  100% {\n    transform: translateY(14px); } }\n@keyframes rainFall2 {\n  0% {\n    transform: translateY(0); }\n  50% {\n    transform: translateY(14px); }\n  100% {\n    transform: translateX(14px) translateY(14px); } }\n@keyframes hailLeft {\n  50% {\n    transform: translateY(17.5px); }\n  51% {\n    transform: translateY(17.5px) translateX(-0.3px); }\n  53% {\n    transform: translateY(16.4033342063px) translateX(-0.9px); }\n  55% {\n    transform: translateY(15.3239634873px) translateX(-1.5px); }\n  57% {\n    transform: translateY(14.278910164px) translateX(-2.1px); }\n  59% {\n    transform: translateY(13.2846553516px) translateX(-2.7px); }\n  61% {\n    transform: translateY(12.3568790424px) translateX(-3.3px); }\n  63% {\n    transform: translateY(11.5102128231px) translateX(-3.9px); }\n  65% {\n    transform: translateY(10.7580091257px) translateX(-4.5px); }\n  67% {\n    transform: translateY(10.1121306519px) translateX(-5.1px); }\n  69% {\n    transform: translateY(9.5827632909px) translateX(-5.7px); }\n  71% {\n    transform: translateY(9.1782554824px) translateX(-6.3px); }\n  73% {\n    transform: translateY(8.9049865561px) translateX(-6.9px); }\n  75% {\n    transform: translateY(8.7672661263px) translateX(-7.5px); }\n  77% {\n    transform: translateY(8.7672661263px) translateX(-8.1px); }\n  79% {\n    transform: translateY(8.9049865561px) translateX(-8.7px); }\n  81% {\n    transform: translateY(9.1782554824px) translateX(-9.3px); }\n  83% {\n    transform: translateY(9.5827632909px) translateX(-9.9px); }\n  85% {\n    transform: translateY(10.1121306519px) translateX(-10.5px); }\n  87% {\n    transform: translateY(10.7580091257px) translateX(-11.1px); }\n  89% {\n    transform: translateY(11.5102128231px) translateX(-11.7px); }\n  91% {\n    transform: translateY(12.3568790424px) translateX(-12.3px); }\n  93% {\n    transform: translateY(13.2846553516px) translateX(-12.9px); }\n  95% {\n    transform: translateY(14.278910164px) translateX(-13.5px); }\n  97% {\n    transform: translateY(15.3239634873px) translateX(-14.1px); }\n  99% {\n    transform: translateY(16.4033342063px) translateX(-14.7px); } }\n@keyframes hailMiddle {\n  50% {\n    transform: translateY(17.5px); }\n  51% {\n    transform: translateY(17.5px) translateX(-0.15px); }\n  53% {\n    transform: translateY(16.4033342063px) translateX(-0.45px); }\n  55% {\n    transform: translateY(15.3239634873px) translateX(-0.75px); }\n  57% {\n    transform: translateY(14.278910164px) translateX(-1.05px); }\n  59% {\n    transform: translateY(13.2846553516px) translateX(-1.35px); }\n  61% {\n    transform: translateY(12.3568790424px) translateX(-1.65px); }\n  63% {\n    transform: translateY(11.5102128231px) translateX(-1.95px); }\n  65% {\n    transform: translateY(10.7580091257px) translateX(-2.25px); }\n  67% {\n    transform: translateY(10.1121306519px) translateX(-2.55px); }\n  69% {\n    transform: translateY(9.5827632909px) translateX(-2.85px); }\n  71% {\n    transform: translateY(9.1782554824px) translateX(-3.15px); }\n  73% {\n    transform: translateY(8.9049865561px) translateX(-3.45px); }\n  75% {\n    transform: translateY(8.7672661263px) translateX(-3.75px); }\n  77% {\n    transform: translateY(8.7672661263px) translateX(-4.05px); }\n  79% {\n    transform: translateY(8.9049865561px) translateX(-4.35px); }\n  81% {\n    transform: translateY(9.1782554824px) translateX(-4.65px); }\n  83% {\n    transform: translateY(9.5827632909px) translateX(-4.95px); }\n  85% {\n    transform: translateY(10.1121306519px) translateX(-5.25px); }\n  87% {\n    transform: translateY(10.7580091257px) translateX(-5.55px); }\n  89% {\n    transform: translateY(11.5102128231px) translateX(-5.85px); }\n  91% {\n    transform: translateY(12.3568790424px) translateX(-6.15px); }\n  93% {\n    transform: translateY(13.2846553516px) translateX(-6.45px); }\n  95% {\n    transform: translateY(14.278910164px) translateX(-6.75px); }\n  97% {\n    transform: translateY(15.3239634873px) translateX(-7.05px); }\n  99% {\n    transform: translateY(16.4033342063px) translateX(-7.35px); } }\n@keyframes hailMiddle2 {\n  50% {\n    transform: translateY(17.5px); }\n  51% {\n    transform: translateY(17.5px) translateX(0.15px); }\n  53% {\n    transform: translateY(16.4033342063px) translateX(0.45px); }\n  55% {\n    transform: translateY(15.3239634873px) translateX(0.75px); }\n  57% {\n    transform: translateY(14.278910164px) translateX(1.05px); }\n  59% {\n    transform: translateY(13.2846553516px) translateX(1.35px); }\n  61% {\n    transform: translateY(12.3568790424px) translateX(1.65px); }\n  63% {\n    transform: translateY(11.5102128231px) translateX(1.95px); }\n  65% {\n    transform: translateY(10.7580091257px) translateX(2.25px); }\n  67% {\n    transform: translateY(10.1121306519px) translateX(2.55px); }\n  69% {\n    transform: translateY(9.5827632909px) translateX(2.85px); }\n  71% {\n    transform: translateY(9.1782554824px) translateX(3.15px); }\n  73% {\n    transform: translateY(8.9049865561px) translateX(3.45px); }\n  75% {\n    transform: translateY(8.7672661263px) translateX(3.75px); }\n  77% {\n    transform: translateY(8.7672661263px) translateX(4.05px); }\n  79% {\n    transform: translateY(8.9049865561px) translateX(4.35px); }\n  81% {\n    transform: translateY(9.1782554824px) translateX(4.65px); }\n  83% {\n    transform: translateY(9.5827632909px) translateX(4.95px); }\n  85% {\n    transform: translateY(10.1121306519px) translateX(5.25px); }\n  87% {\n    transform: translateY(10.7580091257px) translateX(5.55px); }\n  89% {\n    transform: translateY(11.5102128231px) translateX(5.85px); }\n  91% {\n    transform: translateY(12.3568790424px) translateX(6.15px); }\n  93% {\n    transform: translateY(13.2846553516px) translateX(6.45px); }\n  95% {\n    transform: translateY(14.278910164px) translateX(6.75px); }\n  97% {\n    transform: translateY(15.3239634873px) translateX(7.05px); }\n  99% {\n    transform: translateY(16.4033342063px) translateX(7.35px); } }\n@keyframes hailRight {\n  50% {\n    transform: translateY(17.5px); }\n  51% {\n    transform: translateY(17.5px) translateX(0.3px); }\n  53% {\n    transform: translateY(16.4033342063px) translateX(0.9px); }\n  55% {\n    transform: translateY(15.3239634873px) translateX(1.5px); }\n  57% {\n    transform: translateY(14.278910164px) translateX(2.1px); }\n  59% {\n    transform: translateY(13.2846553516px) translateX(2.7px); }\n  61% {\n    transform: translateY(12.3568790424px) translateX(3.3px); }\n  63% {\n    transform: translateY(11.5102128231px) translateX(3.9px); }\n  65% {\n    transform: translateY(10.7580091257px) translateX(4.5px); }\n  67% {\n    transform: translateY(10.1121306519px) translateX(5.1px); }\n  69% {\n    transform: translateY(9.5827632909px) translateX(5.7px); }\n  71% {\n    transform: translateY(9.1782554824px) translateX(6.3px); }\n  73% {\n    transform: translateY(8.9049865561px) translateX(6.9px); }\n  75% {\n    transform: translateY(8.7672661263px) translateX(7.5px); }\n  77% {\n    transform: translateY(8.7672661263px) translateX(8.1px); }\n  79% {\n    transform: translateY(8.9049865561px) translateX(8.7px); }\n  81% {\n    transform: translateY(9.1782554824px) translateX(9.3px); }\n  83% {\n    transform: translateY(9.5827632909px) translateX(9.9px); }\n  85% {\n    transform: translateY(10.1121306519px) translateX(10.5px); }\n  87% {\n    transform: translateY(10.7580091257px) translateX(11.1px); }\n  89% {\n    transform: translateY(11.5102128231px) translateX(11.7px); }\n  91% {\n    transform: translateY(12.3568790424px) translateX(12.3px); }\n  93% {\n    transform: translateY(13.2846553516px) translateX(12.9px); }\n  95% {\n    transform: translateY(14.278910164px) translateX(13.5px); }\n  97% {\n    transform: translateY(15.3239634873px) translateX(14.1px); }\n  99% {\n    transform: translateY(16.4033342063px) translateX(14.7px); } }\n@keyframes fillOpacity {\n  0% {\n    fill-opacity: 0;\n    stroke-opacity: 0; }\n  100% {\n    fill-opacity: 1;\n    stroke-opacity: 1; } }\n@keyframes fillOpacity2 {\n  0% {\n    fill-opacity: 0;\n    stroke-opacity: 0; }\n  50% {\n    fill-opacity: 1;\n    stroke-opacity: 1; }\n  100% {\n    fill-opacity: 0;\n    stroke-opacity: 0; } }\n@keyframes lightningFlash {\n  0% {\n    fill-opacity: 0; }\n  1% {\n    fill-opacity: 1; }\n  2% {\n    fill-opacity: 0; }\n  50% {\n    fill-opacity: 0; }\n  51% {\n    fill-opacity: 1; }\n  52% {\n    fill-opacity: 0; }\n  53% {\n    fill-opacity: 1; }\n  54% {\n    fill-opacity: 0; }\n  100% {\n    fill-opacity: 0; } }\n@keyframes snowFall {\n  0% {\n    transform: translateY(0px) translateX(0px); }\n  2% {\n    transform: translateY(0.35px) translateX(0.7534862344px); }\n  4% {\n    transform: translateY(0.7px) translateX(1.441332186px); }\n  6% {\n    transform: translateY(1.05px) translateX(2.0611944604px); }\n  8% {\n    transform: translateY(1.4px) translateX(2.6112438152px); }\n  10% {\n    transform: translateY(1.75px) translateX(3.0901699437px); }\n  12% {\n    transform: translateY(2.1px) translateX(3.4971832505px); }\n  14% {\n    transform: translateY(2.45px) translateX(3.8320136241px); }\n  16% {\n    transform: translateY(2.8px) translateX(4.0949062299px); }\n  18% {\n    transform: translateY(3.15px) translateX(4.2866143598px); }\n  20% {\n    transform: translateY(3.5px) translateX(4.4083893922px); }\n  22% {\n    transform: translateY(3.85px) translateX(4.4619679282px); }\n  24% {\n    transform: translateY(4.2px) translateX(4.4495561885px); }\n  26% {\n    transform: translateY(4.55px) translateX(4.3738117645px); }\n  28% {\n    transform: translateY(4.9px) translateX(4.2378228353px); }\n  30% {\n    transform: translateY(5.25px) translateX(4.0450849719px); }\n  32% {\n    transform: translateY(5.6px) translateX(3.7994756648px); }\n  34% {\n    transform: translateY(5.95px) translateX(3.5052267202px); }\n  36% {\n    transform: translateY(6.3px) translateX(3.1668946836px); }\n  38% {\n    transform: translateY(6.65px) translateX(2.7893294577px); }\n  40% {\n    transform: translateY(7px) translateX(2.3776412907px); }\n  42% {\n    transform: translateY(7.35px) translateX(1.9371663223px); }\n  44% {\n    transform: translateY(7.7px) translateX(1.4734308761px); }\n  46% {\n    transform: translateY(8.05px) translateX(0.9921147013px); }\n  48% {\n    transform: translateY(8.4px) translateX(0.4990133642px); }\n  50% {\n    transform: translateY(8.75px) translateX(0px); }\n  52% {\n    transform: translateY(9.1px) translateX(-0.4990133642px); }\n  54% {\n    transform: translateY(9.45px) translateX(-0.9921147013px); }\n  56% {\n    transform: translateY(9.8px) translateX(-1.4734308761px); }\n  58% {\n    transform: translateY(10.15px) translateX(-1.9371663223px); }\n  60% {\n    transform: translateY(10.5px) translateX(-2.3776412907px); }\n  62% {\n    transform: translateY(10.85px) translateX(-2.7893294577px); }\n  64% {\n    transform: translateY(11.2px) translateX(-3.1668946836px); }\n  66% {\n    transform: translateY(11.55px) translateX(-3.5052267202px); }\n  68% {\n    transform: translateY(11.9px) translateX(-3.7994756648px); }\n  70% {\n    transform: translateY(12.25px) translateX(-4.0450849719px); }\n  72% {\n    transform: translateY(12.6px) translateX(-4.2378228353px); }\n  74% {\n    transform: translateY(12.95px) translateX(-4.3738117645px); }\n  76% {\n    transform: translateY(13.3px) translateX(-4.4495561885px); }\n  78% {\n    transform: translateY(13.65px) translateX(-4.4619679282px); }\n  80% {\n    transform: translateY(14px) translateX(-4.4083893922px); }\n  82% {\n    transform: translateY(14.35px) translateX(-4.2866143598px); }\n  84% {\n    transform: translateY(14.7px) translateX(-4.0949062299px); }\n  86% {\n    transform: translateY(15.05px) translateX(-3.8320136241px); }\n  88% {\n    transform: translateY(15.4px) translateX(-3.4971832505px); }\n  90% {\n    transform: translateY(15.75px) translateX(-3.0901699438px); }\n  92% {\n    transform: translateY(16.1px) translateX(-2.6112438152px); }\n  94% {\n    transform: translateY(16.45px) translateX(-2.0611944605px); }\n  96% {\n    transform: translateY(16.8px) translateX(-1.441332186px); }\n  98% {\n    transform: translateY(17.15px) translateX(-0.7534862344px); }\n  100% {\n    transform: translateY(17.5px) translateX(-0.0000000001px); } }\n@keyframes snowFall2 {\n  0% {\n    transform: translateY(0px) translateX(0px); }\n  2% {\n    transform: translateY(0.35px) translateX(-0.7534862344px); }\n  4% {\n    transform: translateY(0.7px) translateX(-1.441332186px); }\n  6% {\n    transform: translateY(1.05px) translateX(-2.0611944604px); }\n  8% {\n    transform: translateY(1.4px) translateX(-2.6112438152px); }\n  10% {\n    transform: translateY(1.75px) translateX(-3.0901699437px); }\n  12% {\n    transform: translateY(2.1px) translateX(-3.4971832505px); }\n  14% {\n    transform: translateY(2.45px) translateX(-3.8320136241px); }\n  16% {\n    transform: translateY(2.8px) translateX(-4.0949062299px); }\n  18% {\n    transform: translateY(3.15px) translateX(-4.2866143598px); }\n  20% {\n    transform: translateY(3.5px) translateX(-4.4083893922px); }\n  22% {\n    transform: translateY(3.85px) translateX(-4.4619679282px); }\n  24% {\n    transform: translateY(4.2px) translateX(-4.4495561885px); }\n  26% {\n    transform: translateY(4.55px) translateX(-4.3738117645px); }\n  28% {\n    transform: translateY(4.9px) translateX(-4.2378228353px); }\n  30% {\n    transform: translateY(5.25px) translateX(-4.0450849719px); }\n  32% {\n    transform: translateY(5.6px) translateX(-3.7994756648px); }\n  34% {\n    transform: translateY(5.95px) translateX(-3.5052267202px); }\n  36% {\n    transform: translateY(6.3px) translateX(-3.1668946836px); }\n  38% {\n    transform: translateY(6.65px) translateX(-2.7893294577px); }\n  40% {\n    transform: translateY(7px) translateX(-2.3776412907px); }\n  42% {\n    transform: translateY(7.35px) translateX(-1.9371663223px); }\n  44% {\n    transform: translateY(7.7px) translateX(-1.4734308761px); }\n  46% {\n    transform: translateY(8.05px) translateX(-0.9921147013px); }\n  48% {\n    transform: translateY(8.4px) translateX(-0.4990133642px); }\n  50% {\n    transform: translateY(8.75px) translateX(0px); }\n  52% {\n    transform: translateY(9.1px) translateX(0.4990133642px); }\n  54% {\n    transform: translateY(9.45px) translateX(0.9921147013px); }\n  56% {\n    transform: translateY(9.8px) translateX(1.4734308761px); }\n  58% {\n    transform: translateY(10.15px) translateX(1.9371663223px); }\n  60% {\n    transform: translateY(10.5px) translateX(2.3776412907px); }\n  62% {\n    transform: translateY(10.85px) translateX(2.7893294577px); }\n  64% {\n    transform: translateY(11.2px) translateX(3.1668946836px); }\n  66% {\n    transform: translateY(11.55px) translateX(3.5052267202px); }\n  68% {\n    transform: translateY(11.9px) translateX(3.7994756648px); }\n  70% {\n    transform: translateY(12.25px) translateX(4.0450849719px); }\n  72% {\n    transform: translateY(12.6px) translateX(4.2378228353px); }\n  74% {\n    transform: translateY(12.95px) translateX(4.3738117645px); }\n  76% {\n    transform: translateY(13.3px) translateX(4.4495561885px); }\n  78% {\n    transform: translateY(13.65px) translateX(4.4619679282px); }\n  80% {\n    transform: translateY(14px) translateX(4.4083893922px); }\n  82% {\n    transform: translateY(14.35px) translateX(4.2866143598px); }\n  84% {\n    transform: translateY(14.7px) translateX(4.0949062299px); }\n  86% {\n    transform: translateY(15.05px) translateX(3.8320136241px); }\n  88% {\n    transform: translateY(15.4px) translateX(3.4971832505px); }\n  90% {\n    transform: translateY(15.75px) translateX(3.0901699438px); }\n  92% {\n    transform: translateY(16.1px) translateX(2.6112438152px); }\n  94% {\n    transform: translateY(16.45px) translateX(2.0611944605px); }\n  96% {\n    transform: translateY(16.8px) translateX(1.441332186px); }\n  98% {\n    transform: translateY(17.15px) translateX(0.7534862344px); }\n  100% {\n    transform: translateY(17.5px) translateX(0.0000000001px); } }\n/* Tornado */\n@keyframes translateTornado1 {\n  0% {\n    transform: translateY(0); }\n  25% {\n    transform: translateX(3.997px); }\n  75% {\n    transform: translateX(-3.997px); }\n  100% {\n    transform: translateX(0); } }\n@keyframes translateTornado2 {\n  0% {\n    transform: translateY(0); }\n  25% {\n    transform: translateX(2.002px); }\n  75% {\n    transform: translateX(-2.002px); }\n  100% {\n    transform: translateX(0); } }\n@keyframes translateTornado3 {\n  0% {\n    transform: translateY(0); }\n  25% {\n    transform: translateX(8.001px); }\n  75% {\n    transform: translateX(-8.001px); }\n  100% {\n    transform: translateX(0); } }\n@keyframes translateTornado4 {\n  0% {\n    transform: translateY(0); }\n  25% {\n    transform: translateX(5.999px); }\n  75% {\n    transform: translateX(-5.999px); }\n  100% {\n    transform: translateX(0); } }\n@keyframes translateTornado5 {\n  0% {\n    transform: translateY(0); }\n  25% {\n    transform: translateX(10.003px); }\n  75% {\n    transform: translateX(-10.003px); }\n  100% {\n    transform: translateX(0); } }\n@keyframes translateTornado6 {\n  0% {\n    transform: translateY(0); }\n  25% {\n    transform: translateX(5.999px); }\n  75% {\n    transform: translateX(-5.999px); }\n  100% {\n    transform: translateX(0); } }\n@keyframes fillOpacityLightning {\n  0% {\n    fill-opacity: 0;\n    stroke-opacity: 0; }\n  1% {\n    fill-opacity: 1;\n    stroke-opacity: 1; }\n  7% {\n    fill-opacity: 0;\n    stroke-opacity: 0; }\n  50% {\n    fill-opacity: 0;\n    stroke-opacity: 0; }\n  51% {\n    fill-opacity: 1;\n    stroke-opacity: 1; }\n  53% {\n    fill-opacity: 0;\n    stroke-opacity: 0; }\n  54% {\n    fill-opacity: 1;\n    stroke-opacity: 1; }\n  60% {\n    fill-opacity: 0;\n    stroke-opacity: 0; }\n  100% {\n    fill-opacity: 0;\n    stroke-opacity: 0; } }\n@keyframes translateFog {\n  0% {\n    transform: translateY(0); }\n  25% {\n    transform: translateX(2.499px); }\n  75% {\n    transform: translateX(-2.499px); }\n  100% {\n    transform: translateX(0); } }\n@keyframes fillOpacityFog {\n  0% {\n    fill-opacity: 0.5;\n    stroke-opacity: 0.5; }\n  50% {\n    fill-opacity: 1;\n    stroke-opacity: 1; }\n  100% {\n    fill-opacity: 0.5;\n    stroke-opacity: 0.5; } }\n@keyframes translateSunrise {\n  0% {\n    transform: translateY(0); }\n  25% {\n    transform: translateY(-16.002px); }\n  100% {\n    transform: translateY(-16.002px); } }\n@keyframes translateSunset {\n  0% {\n    transform: translateY(-16.002px); }\n  25% {\n    transform: translateY(-3.997px); }\n  100% {\n    transform: translateY(-3.997px); } }\n@keyframes translateArrowDown {\n  0% {\n    transform: translateY(2.002px); }\n  100% {\n    transform: translateY(4.998px); } }\n@keyframes translateArrowUp {\n  0% {\n    transform: translateY(-2.002px); }\n  100% {\n    transform: translateY(-4.998px); } }\n@keyframes translateWind {\n  0% {\n    transform: translateY(0); }\n  25% {\n    transform: translateX(4.998px); }\n  75% {\n    transform: translateX(-4.998px); }\n  100% {\n    transform: translateX(0); } }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
